export default "__VITE_ASSET__BdPieGHP__"